import { create } from 'zustand';

interface UseImpersonatedUserStore {
  data: string;
  setImpersonatedUser: (user: string) => void;
  clear: () => void;
}

export const useImpersonatedUserStore = create<UseImpersonatedUserStore>((set) => ({
  data: '',

  setImpersonatedUser: (user) => set(() => ({ data: user })),
  clear: () => set(() => ({ data: '' })),
}));
